module.exports = __webpack_public_path__ + "static/media/logoTicketBG.7d2b046a.png";